import { render } from "./ImageTextBlock.vue?vue&type=template&id=28563c6c&scoped=true"
import script from "./ImageTextBlock.vue?vue&type=script&lang=js"
export * from "./ImageTextBlock.vue?vue&type=script&lang=js"

import "./ImageTextBlock.vue?vue&type=style&index=0&id=28563c6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28563c6c"]])

export default __exports__